module.exports = __webpack_public_path__ + "static/media/AVCnurse.a00b5913.svg";